<template>
  <quiz-layout>
    <template #sidebar>
      <div class="sidebar__menu">
        <router-link class="menu__item" :to="`/admin`">
          <div class="item__title">Lessons</div>
        </router-link>
        <router-link class="menu__item" :to="`/admin/users`">
          <div class="item__title">Users</div>
        </router-link>
        <router-link class="menu__item" :to="`/admin/rewards`">
          <div class="item__title">Rewards</div>
        </router-link>
        <router-link class="menu__item" :to="`/admin/rewards/claims`">
          <div class="item__title">Claims</div>
        </router-link>
      </div>
    </template>
    <template>
      <div class="content__title">Lessons</div>
      <div class="content__group">
        <div class="group__item" v-for="(item, key) in lessons" :key="key">
          <div class="group__title">
            {{ item.name }}
          </div>
          <div class="d-flex justify-content-center align-items-center">
            <router-link class="group__action" :to="`/quiz-edit/${item.slug}`">
              View
            </router-link>
          </div>
        </div>
      </div>
    </template>
  </quiz-layout>
</template>
<script>
import { AccountService } from "../data/services/account.service";
import QuizLayout from "../layout/QuizLayout.vue";
export default {
  components: { QuizLayout },
  data() {
    return {
      lessons: [],
    };
  },
  mounted() {
    this.getLessons();
  },
  methods: {
    async getLessons() {
      const accountService = new AccountService();
      const lesson = await accountService.getLessons();
      this.lessons = lesson;
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  &__title {
    font-weight: 500;
    font-size: 22px;
    line-height: 25px;
    margin-bottom: 12px;
  }
  &__group {
    padding: 20px;
    width: 100%;
    background: white;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
  }
}
.group {
  &__item {
    display: flex;
    align-content: center;
    justify-content: space-between;
    + .group__item {
      margin-top: 10px;
    }
  }
  &__title {
    font-size: 16px;
    align-self: center;
    + div {
      margin-left: 10px;
    }
  }
  &__action {
    cursor: pointer;
    font-size: 14px;
    padding: 4px 15px;
    background: #f1bc04;
    color: #ffffff;
    border-radius: 20px;
  }
}

.sidebar {
  &__menu {
    display: flex;
    flex-direction: column;
  }
}

.menu {
  &__item {
    display: flex;
    cursor: pointer;
    align-items: center;
    + .menu__item {
      margin-top: 10px;
    }
  }
}

.item {
  &__icon {
    width: 26px;
    margin-right: 15px;
    svg {
      width: 100%;
    }
  }
  &__title {
    color: #ffffff;
    font-size: 20px;
    line-height: 24px;
    &:hover {
      color: #f1bc04;
    }
  }
}
</style>
